import NoFlightsFound from '@/src/assets/svgs/NoFlightsFound'
import { DeviceType } from '@/src/types/deviceType'
import { Box, Button, Chip, Container, Stack, Typography, useTheme } from '@mui/material'
import { useTranslations } from 'next-intl'

interface FlightNotFoundProps {
    deviceType: DeviceType
    fromAirport: string
    toAirport: string
    appliedFilters: {
        label: string
        onDelete: () => void
        show?: boolean
    }[]
    handleClearAllFilters: () => void
}

const FlightNotFound = ({
    deviceType,
    appliedFilters,
    fromAirport,
    handleClearAllFilters,
    toAirport
}: FlightNotFoundProps) => {
    const theme = useTheme()

    const errorMessageT = useTranslations('srpErrorState')
    const clearAllFiltersT = useTranslations('common')
    return (
        <Box width="100%" height="100%">
            <Container>
                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                    {/* Large SVG Icon with Background */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: 'linear-gradient(rgb(193, 198, 206) -109.98%, rgba(193, 198, 206, 0) 32.6%)',
                            borderRadius: '50%',
                            width: deviceType === 'DESKTOP' ? '350px' : '280px',
                            height: deviceType === 'DESKTOP' ? '350px' : '280px',
                            marginTop: deviceType === 'DESKTOP' ? '50px' : '40px'
                            // marginBottom: '20px'
                        }}
                    >
                        <Box sx={{ marginTop: deviceType === 'DESKTOP' ? '60px' : '20px' }}>
                            <NoFlightsFound
                                sx={{
                                    fontSize: deviceType === 'DESKTOP' ? 300 : 160,
                                    color: theme.palette.primary.main,
                                    opacity: 1
                                }}
                            />
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            marginTop: deviceType === 'DESKTOP' ? '50px' : '20px',
                            maxWidth: deviceType === 'DESKTOP' ? '550px' : '300px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}
                    >
                        {/* Main Message */}
                        <Typography
                            variant={deviceType === 'DESKTOP' ? 'h5' : 'h6'}
                            color="text.primary"
                            fontWeight="600"
                            mb={2}
                            sx={{ lineHeight: 1.3 }}
                        >
                            {errorMessageT('noFlightsFoundPrimary', { from: fromAirport || '', to: toAirport || '' })}
                        </Typography>

                        {/* Sub Message */}
                        <Typography
                            variant="body1"
                            color="text.secondary"
                            mb={4}
                            sx={{
                                maxWidth: '400px',
                                lineHeight: 1.5
                            }}
                        >
                            {errorMessageT('noFlightsFoundSecondary')}
                        </Typography>

                        <Stack direction="row" flexWrap="wrap" sx={{ gap: 1 }}>
                            {appliedFilters.map(chip =>
                                chip.show ? (
                                    <Chip
                                        key={chip.label}
                                        color="primary"
                                        label={chip.label}
                                        variant="outlined"
                                        onDelete={chip.onDelete}
                                        onClick={chip.onDelete}
                                    />
                                ) : null
                            )}
                        </Stack>

                        <Button
                            variant="customVariantPrimary"
                            color="primary"
                            size="large"
                            onClick={handleClearAllFilters}
                            sx={{ marginTop: '20px', marginBottom: '20px' }}
                        >
                            {clearAllFiltersT('clearAllFilters')}
                        </Button>
                    </Box>
                </Box>
            </Container>
        </Box>
    )
}

export default FlightNotFound
